export default "declare module 'str-utils' {\n    // export const ...\n    // export function ...\n}\n";